<template>
  <div :class="classes">
    <div class="price-display__outer-circle">
      <div class="price-display__inner-circle">
        <div v-if="isApproximation" class="price-display__label">{{ $t('result.approximate_costs') }}</div>
        <div class="price-display__price">
          <span v-if="isValid && isNotNullish(price)">{{ formatPrice(props.price!) }}</span>
          <span v-else>
            <span
              class="price-display__invalid"
              role="img"
              :aria-label="$t('result.monthly_cost_unavailable')"
              :title="$t('result.monthly_cost_unavailable')"
            ></span>
            €
          </span>
        </div>
        <div class="price-display__label">{{ $t('result.per_month') }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { formatPrice } from '@/services/helper.service.ts'
import { isNotNullish } from '@/helpers/type-checks.ts'
import type { APriceDisplayProps } from './a-price-display-props'

const props = withDefaults(defineProps<APriceDisplayProps>(), { isApproximation: false })

const classes = computed(() => {
  return {
    'price-display': true,
    'price-display__is-loading': props.isLoading,
    'price-display__is-valid': props.isValid
  }
})
</script>

<style lang="scss" scoped>
@import 'a-price-display';
</style>
